import { httpCreate } from './http';

const http = httpCreate('/srv/watchConfig');

export const watchConfig = {
	// 保存设置
	save(data) {
		return http.post('/save/config', data);
	},
	// 获取观看权限
	checkPermission(id) {
		return http.get(`/checkPermission/${id}`);
	},
	// 获取观看设置
	find(id) {
		return http.get(`/find/config/${id}`);
	},
	// 获取观看列表
	watchList(id, params) {
		return http.get(`/watchList/${id}`, { params });
	},
	// 导出观看列表
	exportExcel(id) {
		return http.get(`/${id}/exportExcel`);
	},
	// 下载白名单模板
	download() {
		return http.get('/download/template');
	},
	// 导入白名单
	importWhiteList(id, data) {
		return http.post(`/importWhiteList/${id}`, data);
	},
	//白名单列表
	whitesList(activityId, params) {
		return http.get(`activityWhites/${activityId}`, {
			params,
		});
	},
	// 调查问卷表
	surveyList(activityId) {
		return http.get(`surveyList/${activityId}`);
	},
	// 新的查看列表接口
	watchListNew(activityId, params) {
		// activityId
		// id 起始id，上一页传第一个，下一页传最后一个
		// num = pageSize
		// dir 0 上一页 1 下一页
		// flag 0 6个月内 1 6个月前
		// startTime
		// endTime
		return http.get(`watchListNew/${activityId}`, { params: params });
	},
	// 解绑报名表
	unboundSurvey(activityId) {
		return http.post(`survey/unBound/${activityId}`);
	},
	setSurvey(activityId, surveyId) {
		return http.post(`/survey/bound/${activityId}/${surveyId}`);
	},
	// 评论区拉黑/解封
	blackList(activityId, watchId, status) {
		return http.post(`/${activityId}/black/${watchId}/${status}`);
	},
	// 定制，清除观看数据 或许之后会成为通用接口
	clear(activityId) {
		return http.delete(`/clear/${activityId}`);
	},
	saveSurveyTip(activityId, body) {
		return http.post(`/save/config/${activityId}`, body);
	},
	resell(params) {
		return http.get('/resell', { params: params });
	},
	saveWhiteStyle(id, params) {
		return http.post(`/save/whiteStyle/${id}`, params);
	},
};
